var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4982",
    "data-name": "Group 4982",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4981",
    "data-name": "Group 4981",
    transform: "translate(6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5974",
    "data-name": "Path 5974",
    d: "M203.5,308a.5.5,0,0,1-.354-.854l5-5a.5.5,0,0,1,.708.708l-5,5A.5.5,0,0,1,203.5,308Z",
    transform: "translate(-198 -288)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5975",
    "data-name": "Path 5975",
    d: "M203.5,308a.5.5,0,0,1-.354-.146l-5-5a.5.5,0,0,1,.708-.708l5,5a.5.5,0,0,1-.354.854Z",
    transform: "translate(-198 -288)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5976",
    "data-name": "Path 5976",
    d: "M203.5,308a.5.5,0,0,1-.5-.5v-19a.5.5,0,0,1,1,0v19A.5.5,0,0,1,203.5,308Z",
    transform: "translate(-198 -288)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5977",
    "data-name": "Path 5977",
    d: "M213.5,312H193.479A1.491,1.491,0,0,1,192,310.5v-5a.5.5,0,0,1,1,0v5a.49.49,0,0,0,.479.5H213.5a.507.507,0,0,0,.5-.5v-5a.5.5,0,0,1,1,0v5A1.5,1.5,0,0,1,213.5,312Z",
    transform: "translate(-192 -288)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.9b93c204c6fb58fb604b889cd4ef4888.svg";
export { ForwardRef as ReactComponent };